import { RIGHT_OF_ENTRY_STATUS_CONSTANTS } from 'utils/constants';

const alpha = 175;
const getRandomColor = () => {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    const randLetter = Math.floor(Math.random() * 16);
    color += letters[randLetter];
  }
  return color;
};

const ROE_STATUS_COLORS = {
  APPROVED: {
    Color: '#43A047',
    Rgb: [67, 160, 71, 1.0],
  },
  DENIED: {
    Color: '#EB0000',
    Rgb: [235, 0, 0, 1.0],
  },
  INVALIDATED: {
    Color: '#F06C00',
    Rgb: [255, 108, 0, 1.0],
  },
  'PENDING REVIEW': {
    Color: '#1D4777',
    Rgb: [29, 71, 119],
  },
  'NOT SIGNED': {
    Color: '#F6A609',
    Rgb: [246, 166, 9, 1.0],
  },
};

// map ROE_STATUS_COLORS to ROE_STATUS_CONSTANT values
const roeStatus = Object.values(RIGHT_OF_ENTRY_STATUS_CONSTANTS).reduce((acc, value) => {
  acc[value] = ROE_STATUS_COLORS[value.toUpperCase()];
  return acc;
}, {});

const ML_PREDICT_COLORS = {
  RANDOM_COLOR: {
    Color: getRandomColor(),
    Rgb: [0, 0, 0, 1.0],
  },
  'HIGH (> 90%)': {
    Color: '#FF825B',
    Rgb: [255, 130, 91, 1.0],
  },
  'MEDIUM (50% - 90%)': {
    Color: '#FFDACE',
    Rgb: [255, 218, 206, 1.0],
  },
  'LOW - MEDIUM (10% - 50%)': {
    Color: '#B4E2E6',
    Rgb: [180, 226, 230, 1.0],
  },
  'LOW (< 10%)': {
    Color: '#00A1AA',
    Rgb: [0, 161, 170, 1.0],
  },
  PREDICT_HIGH: {
    Color: '#FF825B',
    Rgb: [255, 130, 91, 1.0],
  },
  PREDICT_MEDIUM: {
    Color: '#FFDACE',
    Rgb: [255, 218, 206, 1.0],
  },
  'PREDICT_LOW - MEDIUM': {
    Color: '#B4E2E6',
    Rgb: [180, 226, 230, 1.0],
  },
  PREDICT_LOW: {
    Color: '#00A1AA',
    Rgb: [0, 161, 170, 1.0],
  },
};
const lightColor = {
  mode: 'light',
  background: {
    default: '#F5F5F5',
    paper: '#f5f5f5',
    innerCard: '#fff',
    topBar: '#fff',
  },

  text: {
    main: '#052838',
    focus: '#052838',
    secondary: '#6c757d',
  },

  cardDefault: {
    backgroundColor: '#fff',
  },

  cardSecondary: {
    backgroundColor: '#f1f1f1',
  },

  transparent: {
    main: 'transparent',
  },

  white: {
    main: '#ffffff',
    focus: '#ffffff',
  },

  black: {
    light: '#000000',
    main: '#000000',
    focus: '#000000',
  },

  primary: {
    main: '#052838',
    focus: '#052838',
  },

  secondary: {
    main: '#018F99',
    focus: '#018F99',
  },

  info: {
    main: '#0288d1',
    focus: '#01579b',
  },

  success: {
    main: '#2e7d32',
    focus: '#1b5e20',
  },

  warning: {
    main: '#ed6c02',
    focus: '#e65100',
  },

  error: {
    main: '#D32F2F',
    focus: '#c62828',
  },

  light: {
    main: '#F5F5F5',
    focus: '#F5F5F5',
  },

  dark: {
    main: '#303030',
    focus: '#303030',
  },

  grey: {
    /* not altered */ 100: '#f8f9fa',
    200: '#f0f2f5',
    300: '#dee2e6',
    400: '#ced4da',
    500: '#adb5bd',
    600: '#6c757d',
    700: '#495057',
    800: '#343a40',
    900: '#212529',
  },

  gradients: {
    primary: {
      main: '#044457',
      state: '#018F99',
    },

    /* Rest of Gradients not altered */
    secondary: {
      main: '#747b8a',
      state: '#495361',
    },

    info: {
      main: '#49a3f1',
      state: '#1A73E8',
    },

    success: {
      main: '#66BB6A',
      state: '#43A047',
    },

    warning: {
      main: '#FFA726',
      state: '#FB8C00',
    },

    error: {
      main: '#EF5350',
      state: '#E53935',
    },

    light: {
      main: '#EBEFF4',
      state: '#CED4DA',
    },

    dark: {
      main: '#42424a',
      state: '#191919',
    },
  },

  borderColors: {
    /* Rest of variables on page not altered */
    light: {
      background: '#ffffff',
      text: '#c7d3de',
    },

    dark: {
      background: '#8097bf',
      text: '#1e2e4a',
    },
  },

  coloredShadows: {
    primary: '#e91e62',
    secondary: '#110e0e',
    info: '#00bbd4',
    success: '#4caf4f',
    warning: '#ff9900',
    error: '#f44336',
    light: '#adb5bd',
    dark: '#404040',
    contrast: '#000',
  },

  inputBorderColor: '#d2d6da',

  tabs: {
    indicator: { boxShadow: '#ddd' },
  },

  card: {
    selected: 'lightgray',
    unselected: '#fff',
  },
};

const darkColor = {
  mode: 'dark',
  background: {
    default: '#303030',
    paper: '#303030',
    innerCard: '#424242',
    topBar: '#424242',
  },

  text: {
    main: '#ffffff',
    focus: '#ffffff',
    secondary: '#ced4da',
  },

  cardDefault: {
    backgroundColor: '#424242',
  },

  cardSecondary: {
    backgroundColor: '#5D5D5D',
  },

  transparent: {
    main: 'transparent',
  },

  white: {
    main: '#ffffff',
    focus: '#ffffff',
  },

  black: {
    light: '#000000',
    main: '#000000',
    focus: '#000000',
  },

  primary: {
    main: '#ffffff',
    focus: '#ffffff',
  },

  secondary: {
    main: '#054457',
    focus: '#054457',
  },

  info: {
    main: '#03a9f4',
    focus: '#0288d1',
  },

  success: {
    main: '#4caf50',
    focus: '#2e7d32',
  },

  warning: {
    main: '#ff9800',
    focus: '#ed6c02',
  },

  error: {
    main: '#F2706E',
    focus: '#ef5350',
  },

  light: {
    main: '#F5F5F5',
    focus: '#F5F5F5',
  },

  dark: {
    main: '#303030',
    focus: '#303030',
  },

  grey: {
    /* not altered */ 100: '#f8f9fa',
    200: '#f0f2f5',
    300: '#dee2e6',
    400: '#ced4da',
    500: '#adb5bd',
    600: '#6c757d',
    700: '#495057',
    800: '#343a40',
    900: '#212529',
  },

  gradients: {
    primary: {
      main: '#054457',
      state: '#00383B',
    },

    /* Rest of Gradients not altered */
    secondary: {
      main: '#747b8a',
      state: '#495361',
    },

    info: {
      main: '#49a3f1',
      state: '#1A73E8',
    },

    success: {
      main: '#66BB6A',
      state: '#43A047',
    },

    warning: {
      main: '#FFA726',
      state: '#FB8C00',
    },

    error: {
      main: '#EF5350',
      state: '#E53935',
    },

    light: {
      DETECT: {
        Color: '#1B5E20',
        Rgb: '27, 94, 32, 200',
      },
      'NON-DETECT': {
        Color: '#43A047',
        Rgb: '67, 160, 71, 200',
      },
      EXCEEDANCE: {
        Color: '#F50000',
        Rgb: '212, 22, 29, 200',
      },
      'KIT SHIPPED': {
        Color: '#3274c0',
        Rgb: '50, 116, 192, 200',
      },
      'NOT ELIGIBLE': {
        Color: '#424242',
        Rgb: '66, 66, 66, 200',
      },
      ELIGIBLE: {
        Color: '#757575',
        Rgb: '117, 117, 117, 200',
      },
      REJECTED: {
        Color: '#EEEE03',
        Rgb: '238, 238, 3, 225',
      },
      'PENDING APPROVAL': {
        Color: '#808080',
        Rgb: '128, 128, 128, 225',
      },
      'PENDING APPROVAL (UNVERIFIED CUSTOMER)': {
        Color: '#808080',
        Rgb: '128, 128, 128, 225',
      },
      'GALV REQ REPLACEMENT': {
        Color: '#F06C00',
        Rgb: '240, 108, 0, 225',
      },
      VERIFIED: {
        Color: '#00994C',
        Rgb: '0, 153, 0, 225',
      },
      'SENT BACK FOR RESUBMITTAL': {
        Color: '#9966FF',
        Rgb: '153, 102, 255, 225',
      },
      NONE: {
        Color: '#FFCCFF',
        Rgb: '255, 204, 255, 225',
      },
      LEAD: {
        Color: '#F50000',
        Rgb: '245, 0, 0, 225',
      },
      'NON-LEAD': {
        Color: '#20A76C',
        Rgb: '32, 167, 108, 225',
      },
      'POTENTIAL LEAD': {
        Color: '#F06C00',
        Rgb: '240, 108, 0, 225',
      },
      'LEAD STATUS UNKNOWN': {
        Color: '#1D4777',
        Rgb: '29,71,119, 225',
      },
      // REPLACEMENT STATUSES
      COMPLETE: {
        Color: '#00D084',
        Rgb: '0, 208, 132, 225',
      },
      'IN PROGRESS': {
        Color: '#7BDBC5',
        Rgb: '123, 219, 197, 225',
      },
      'NOT STARTED': {
        Color: '#EB144C',
        Rgb: '235, 20, 76, 225',
      },
      APPROVED: {
        Color: '#43A047',
        Rgb: [67, 160, 71, 1.0],
      },
      DENIED: {
        Color: '#EB0000',
        Rgb: [235, 0, 0, 1.0],
      },
      INVALIDATED: {
        Color: '#F06C00',
        Rgb: [255, 108, 0, 1.0],
      },
      'NOT SIGNED': {
        Color: '#F6A609',
        Rgb: [246, 166, 9, 1.0],
      },
      HIGH: {
        Color: '#FF6F42',
        Rgb: [255, 111, 66, alpha],
      },
      MEDIUM: {
        Color: '#FDC70C',
        Rgb: [238, 190, 65, alpha],
      },
      LOW: {
        Color: '#7BE1E6',
        Rgb: [123, 225, 230, alpha],
      },
      TRINNEXGREEN: {
        Color: '#00a1aa',
        Rgb: [0, 161, 170, alpha],
      },
      MLHIGH: {
        Color: '#FBA58A',
        Rgb: [251, 165, 138, 0.8],
      },
      MLMEDIUM: {
        Color: '#FAD969',
        Rgb: [250, 217, 105, 0.8],
      },
      MLLOW: {
        Color: '#ACE9EC',
        Rgb: [172, 233, 236, 0.8],
      },
      ...ML_PREDICT_COLORS,
      SAMPLEKIT: {
        Color: '#6666CC',
        Rgb: '102,102,204, 100',
      },
      YES: {
        Color: '#FF6F42',
        Rgb: [255, 111, 66, alpha],
      },
      NO: {
        Color: '#20A76C',
        Rgb: '32, 167, 108, 225',
      },
      main: '#EBEFF4',
      state: '#CED4DA',
    },

    dark: {
      main: '#42424a',
      state: '#191919',
    },
  },

  borderColor: {
    /* Rest of variables on page not altered */
    light: {
      background: '#ffffff',
      text: '#c7d3de',
    },

    dark: {
      background: '#8097bf',
      text: '#1e2e4a',
    },
  },

  coloredShadows: {
    primary: '#e91e62',
    secondary: '#110e0e',
    info: '#00bbd4',
    success: '#4caf4f',
    warning: '#ff9900',
    error: '#f44336',
    light: '#adb5bd',
    dark: '#404040',
    contrast: '#fff',
  },

  inputBorderColor: '#d2d6da',

  tabs: {
    indicator: { boxShadow: '#ddd' },
  },

  card: {
    selected: 'dimgray',
    unselected: '#333333',
  },
};

const productColors = {
  TRINNEXGREEN: {
    Color: '#00a1aa',
    Rgb: [0, 161, 170, alpha],
  },
  publicMap: {
    default: {
      LEAD: {
        Color: '#F50000',
        Rgb: [245, 0, 0, 225],
      },
      'LEAD STATUS UNKNOWN': {
        Color: '#1D4777',
        Rgb: [29, 71, 119, 225],
      },
      'NON-LEAD': {
        Color: '#20A76C',
        Rgb: [632, 167, 108, 225],
      },
      'GALV REQ REPLACEMENT': {
        Color: '#F06C00',
        Rgb: [240, 108, 0, 225],
      },
      TRINNEXGREEN: {
        Color: '#00a1aa',
        Rgb: [0, 161, 170, alpha],
      },
    },
    colorBlind: {
      LEAD: {
        Color: '#BD3535',
        Rgb: [189, 53, 53, 1],
      },
      'NON-LEAD': {
        Color: '#2D8580',
        Rgb: [45, 133, 128, 1],
      },
      'LEAD STATUS UNKNOWN': {
        Color: '#456EFF',
        Rgb: [69, 110, 255, 1],
      },
      'GALV REQ REPLACEMENT': {
        Color: '#371452',
        Rgb: [55, 20, 82, 1],
      },
      TRINNEXGREEN: {
        Color: '#00a1aa',
        Rgb: [0, 161, 170, alpha],
      },
    },
  },
  light: {
    NULL: {
      Color: '#000000',
      Rgb: '0,0,0',
    },
    REJECTED: {
      Color: '#EEEE03',
      Rgb: '238, 238, 3, 225',
    },
    'PENDING APPROVAL': {
      Color: '#808080',
      Rgb: '128, 128, 128, 225',
    },
    'PENDING APPROVAL (UNVERIFIED CUSTOMER)': {
      Color: '#808080',
      Rgb: '128, 128, 128, 225',
    },
    'GALV REQ REPLACEMENT': {
      Color: '#F06C00',
      Rgb: '240, 108, 0, 225',
    },
    VERIFIED: {
      Color: '#00994C',
      Rgb: '0, 153, 0, 225',
    },
    'SENT BACK FOR RESUBMITTAL': {
      Color: '#9966FF',
      Rgb: '153, 102, 255, 225',
    },
    NONE: {
      Color: '#FFCCFF',
      Rgb: '255, 204, 255, 225',
    },
    DETECT: {
      Color: '#1B5E20',
      Rgb: '27, 94, 32, 200',
    },
    DETECTED: {
      Color: '#1B5E20',
      Rgb: '27, 94, 32, 200',
    },
    'NON-DETECT': {
      Color: '#43A047',
      Rgb: '67, 160, 71, 200',
    },
    'NO DETECTION': {
      Color: '#43A047',
      Rgb: '67, 160, 71, 200',
    },
    EXCEEDANCE: {
      Color: '#F50000',
      Rgb: '212, 22, 29, 200',
    },
    'KIT SHIPPED': {
      Color: '#3274c0',
      Rgb: '50, 116, 192, 200',
    },
    'NOT ELIGIBLE': {
      Color: '#424242',
      Rgb: '66, 66, 66, 200',
    },
    ELIGIBLE: {
      Color: '#757575',
      Rgb: '117, 117, 117, 200',
    },
    LEAD: {
      Color: '#F50000',
      Rgb: '245, 0, 0, 225',
    },
    'NON-LEAD': {
      Color: '#20A76C',
      Rgb: '32, 167, 108, 225',
    },
    'POTENTIAL LEAD': {
      Color: '#F06C00',
      Rgb: '240, 108, 0, 225',
    },
    'LEAD STATUS UNKNOWN': {
      Color: '#1D4777',
      Rgb: '29,71,119, 225',
    },
    // REPLACEMENT STATUSES
    // NOTE 09/08/23: The Added replacements section below likely retires these statuses.
    // If so, these can be removed.
    COMPLETE: {
      Color: '#43A047',
      Rgb: [67, 160, 71, 1.0],
    },
    'IN PROGRESS': {
      Color: '#1976D2',
      Rgb: [25, 118, 210, 1.0],
    },
    'PENDING REVIEW': {
      Color: '#92c2f2',
      Rgb: [146, 194, 242, 1.0],
    },
    RESUBMITTED: {
      Color: '#92c2f2',
      Rgb: [146, 194, 242, 1.0],
    },
    'APPROVED WITH SUGGESTIONS': {
      Color: '#43A047',
      Rgb: [67, 160, 71, 1.0],
    },
    APPROVED: {
      Color: '#43A047',
      Rgb: [67, 160, 71, 1.0],
    },
    DENIED: {
      Color: '#EB0000',
      Rgb: [235, 0, 0, 1.0],
    },
    INVALIDATED: {
      Color: '#F06C00',
      Rgb: [255, 108, 0, 1.0],
    },
    'NOT SIGNED': {
      Color: '#F6A609',
      Rgb: [246, 166, 9, 1.0],
    },
    HIGH: {
      Color: '#FF6F42',
      Rgb: [255, 111, 66, alpha],
    },
    MEDIUM: {
      Color: '#FDC70C',
      Rgb: [238, 190, 65, alpha],
    },
    LOW: {
      Color: '#7BE1E6',
      Rgb: [123, 225, 230, alpha],
    },
    TRINNEXGREEN: {
      Color: '#00a1aa',
      Rgb: [0, 161, 170, alpha],
    },
    MLHIGH: {
      Color: '#FBA58A',
      Rgb: [251, 165, 138, 0.8],
    },
    MLMEDIUM: {
      Color: '#FAD969',
      Rgb: [250, 217, 105, 0.8],
    },
    MLLOW: {
      Color: '#ACE9EC',
      Rgb: [172, 233, 236, 0.8],
    },
    PRIVATE: {
      Color: '#343434',
      Rgb: [52, 52, 52, 1],
    },
    PRIVATE_HIGHLIGHTED: {
      Color: '#00BFFF',
      Rgb: [0, 191, 255, 1],
    },
    UTILITY: {
      Color: '#828282',
      Rgb: [130, 130, 130, 1],
    },
    UTILITY_HIGHLIGHTED: {
      Color: '#80DFFF',
      Rgb: [128, 223, 255, 1],
    },
    ...ML_PREDICT_COLORS,
    SAMPLEKIT: {
      Color: '#6666CC',
      Rgb: '102,102,204, 100',
    },
    YES: {
      Color: '#FF6F42',
      Rgb: [255, 111, 66, alpha],
    },
    NO: {
      Color: '#20A76C',
      Rgb: '32, 167, 108, 225',
    },
    INSPECTION_OPTIMIZER: {
      Primary: {
        Color: '#43A047',
        Rgb: [67, 160, 71, 1],
      },
      Alternate: {
        Color: '#6666CC',
        Rgb: [102, 102, 204, 1],
      },
      'Utility Recommended': {
        Color: '#C5C5C5',
        Rgb: [197, 197, 197, 1],
      },
      'Private Recommended': {
        Color: '#FF0000',
        Rgb: [255, 0, 0, 1],
      },
    },
    ['Right of Entry Status']: ROE_STATUS_COLORS,
    PRIMARY: {
      Color: '#43A047',
      Rgb: [67, 160, 71, 1],
    },
    ALTERNATE: {
      Color: '#6666CC',
      Rgb: [102, 102, 204, 1],
    },
    'VERIFICATION RECOMMENDED': {
      Color: '#FFA200',
      Rgb: [255, 162, 0, 1],
    },
    'VERIFICATION NOT RECOMMENDED': {
      Color: '#24FF00',
      Rgb: [255, 0, 0, 1],
    },
    UNKNOWN: {
      Color: '#C5C5C5',
      Rgb: [197, 197, 197, 1],
    },
  },
  dark: {
    DETECT: {
      Color: '#32B33D',
      Rgb: '50, 179, 61, 200',
    },
    'NON-DETECT': {
      Color: '#8ECC95',
      Rgb: '142, 204, 149, 200',
    },
    EXCEEDANCE: {
      Color: '#FF7043',
      Rgb: '255, 112, 67, 200',
    },
    'KIT SHIPPED': {
      Color: '#9ABAE5',
      Rgb: '154, 186, 229, 200',
    },
    'NOT ELIGIBLE': {
      Color: '#9E9E9E',
      Rgb: '158, 158, 158, 200',
    },
    ELIGIBLE: {
      Color: '#DEDEDE',
      Rgb: '222, 222, 222, 200',
    },
    LEAD: {
      Color: '#FF5252',
      Rgb: '255, 82, 82, 225',
    },
    'NON-LEAD': {
      Color: '#20A76C',
      Rgb: '32, 167, 108, 225',
    },
    'POTENTIAL LEAD': {
      Color: '#F06C00',
      Rgb: '240, 108, 0, 225',
    },
    'LEAD STATUS UNKNOWN': {
      Color: '#5B95D7',
      Rgb: '91, 149, 215, 225',
    },
    'GALV REQ REPLACEMENT': {
      Color: '#FFE666',
      Rgb: '255, 230, 102, 225',
    },
    // REPLACEMENT STATUSES (Note: dark theme colors match light themes for they are TBD)
    // NOTE 09/08/23: The Added replacements section below likely retires these statuses.
    // If so, these can be removed.
    COMPLETE: {
      Color: '#00D084',
      Rgb: '0, 208, 132, 225',
    },
    'IN PROGRESS': {
      Color: '#7BDBC5',
      Rgb: '123, 219, 197, 225',
    },
    'NOT STARTED': {
      Color: '#EB144C',
      Rgb: '235, 20, 76, 225',
    },
    APPROVED: {
      Color: '#43A047',
      Rgb: [67, 160, 71, 1.0],
    },
    DENIED: {
      Color: '#EB0000',
      Rgb: [235, 0, 0, 1.0],
    },
    INVALIDATED: {
      Color: '#F06C00',
      Rgb: [255, 108, 0, 1.0],
    },
    'NOT SIGNED': {
      Color: '#F6A609',
      Rgb: [246, 166, 9, 1.0],
    },
    HIGH: {
      Color: '#FF6F42',
      Rgb: [255, 111, 66, alpha],
    },
    MEDIUM: {
      Color: '#FDC70C',
      Rgb: [238, 190, 65, alpha],
    },
    LOW: {
      Color: '#7BE1E6',
      Rgb: [123, 225, 230, alpha],
    },
    TRINNEXGREEN: {
      Color: '#00a1aa',
      Rgb: [0, 161, 170, alpha],
    },
    MLHIGH: {
      Color: '#FBA58A',
      Rgb: [251, 165, 138, 0.8],
    },
    MLMEDIUM: {
      Color: '#FAD969',
      Rgb: [250, 217, 105, 0.8],
    },
    MLLOW: {
      Color: '#ACE9EC',
      Rgb: [172, 233, 236, 0.8],
    },
    ...ML_PREDICT_COLORS,
    SAMPLEKIT: {
      Color: '#3D8FEE',
      Rgb: '61,143,238, 100',
    },
    YES: {
      Color: '#FF6F42',
      Rgb: [255, 111, 66, alpha],
    },
    NO: {
      Color: '#20A76C',
      Rgb: '32, 167, 108, 225',
    },
  },
  replacements: {
    'Not Applicable': {
      Color: '#000000',
      Rgb: [0, 0, 0, 1.0],
    },
    Unassigned: {
      Color: '#757575',
      Rgb: [117, 117, 117, 1.0],
    },
    Planned: {
      Color: '#1976D2',
      Rgb: [25, 118, 210, 1.0],
    },
    'In replacement pool': {
      Color: '#1976D2',
      Rgb: [25, 118, 210, 1.0],
    },
    'Scheduled in idle phase': {
      Color: '#1976D266',
      Rgb: [25, 118, 210, 0.4],
    },
    'Scheduled in active phase': {
      Color: '#1976D266',
      Rgb: [25, 118, 210, 0.4],
    },
    Prereplacement: {
      Color: '#1976D2',
      Rgb: [25, 118, 210, 1.0],
    },
    'In Progress': {
      Color: '#92c2f2',
      Rgb: '146, 194, 242, 225',
    },
    roeStatus,
    'Pending ROE': {
      Color: '#F6A609',
      Rgb: [246, 166, 9, 1.0],
    },
    'ROE denied': {
      Color: '#EB0000',
      Rgb: [235, 0, 0, 1.0],
    },
    'Closed due to ROE': {
      Color: '#EB0000',
      Rgb: [235, 0, 0, 1.0],
    },
    Replacement: {
      Color: '#1976D2',
      Rgb: [25, 118, 210, 1.0],
    },
    'Pending Review': {
      // Color: '#1976D266',
      // Rgb: [25, 118, 210, 0.4],
      Color: '#00DC8C',
      Rgb: [0, 220, 140, 1.0],
    },
    Resubmitted: {
      Color: '#00DC8C',
      Rgb: [0, 220, 140, 1.0],
    },
    'Sent Back For Corrections': {
      Color: '#F6A609',
      Rgb: [246, 166, 9, 1.0],
    },
    'Replacement Completed': {
      Color: '#1976d2',
      Rgb: [25, 118, 210, 1.0],
    },
    'Revisions Requested': {
      Color: '#A60000',
      Rgb: [166, 0, 0, 1.0],
    },
    'Verified Non-Lead': {
      Color: '#20a76c',
      Rgb: [32, 167, 108, 1.0],
    },
    'Confirmed Lead': {
      Color: '#43A047',
      Rgb: [67, 160, 71, 1.0],
    },
    'Partial Replacement Conducted': {
      Color: '#1919d1',
      Rgb: [25, 25, 209, 1.0],
    },
    'Galv Replacement Completed': {
      Color: '#A08E2C',
      Rgb: [160, 142, 44, 1.0],
    },
    Approved: {
      Color: '#20A76C',
      Rgb: [67, 160, 71, 1.0],
    },
    'Approved with Suggestions': {
      Color: '#20A76C',
      Rgb: [67, 160, 71, 1.0],
    },
    Restoration: {
      Color: '#1976D2',
      Rgb: [25, 118, 210, 1.0],
    },
    'Project complete': {
      Color: '#43A047',
      Rgb: [67, 160, 71, 1.0],
    },
    Completed: {
      Color: '#43A047',
      Rgb: [67, 160, 71, 1.0],
    },
    'Prereplacement Review': {
      Color: '#F6A609',
      Rgb: [246, 166, 9, 1.0],
    },
  },
};

export { lightColor, darkColor, productColors };
